// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___vBCPF","avatarWrapper":"styles__avatarWrapper___16aHv"};